import "./OvenCleaningAlAqiq.module.css";
import Header from "@/reusable_sections/Header";
import AqeeqOvenServiceHero from "./sections/AqeeqOvenServiceHero";
import AlAqiqService from "./sections/AlAqiqService";
import Footer from "@/reusable_sections/Footer";
export default function OvenCleaningAlAqiqPage() {
  return <div>
      <Header />
      <AqeeqOvenServiceHero />
      <AlAqiqService />
      <Footer />
    </div>;
}